import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  accessToken: string | null;
  phone: string | null;
  isAdmin: boolean;
  setAuth: (token: string, phone: string, isAdmin: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    set => ({
      accessToken: null,
      phone: null,
      isAdmin: false,
      setAuth: (accessToken, phone, isAdmin) => {
        localStorage.setItem('accessToken', accessToken);
        set({ accessToken, phone, isAdmin });
      },
      logout: () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        set({ accessToken: null, phone: null, isAdmin: false });
      },
    }),
    { name: 'sekarsilks-auth', partialize: state => ({ phone: state.phone, isAdmin: state.isAdmin }) },
  ),
);
